'use strict';

angular.module('teams')
	.directive('teamMemberInfo',[function() {
		return {
			restrict: 'E',
			scope:
			{
				user : '='
			},
			link: function (scope, elem, attrs) {

				// Watch the user till we got valid data
				var userWatch = scope.$watch('user', function(user){
					if (user) {

						// Remove the watcher now that we have the needed data
						userWatch();

						var displayString = '';
						if (scope.user && scope.user.hasOwnProperty('email')) {
							if (scope.user.email && scope.user.email.indexOf('github.com/') !== 0) {
								displayString += '(' + scope.user.email + ')';
							}
						}

						// Display the user-information
						elem.html(displayString);
					}
				});

			}
		};
	}]);
